<template>
	<div class="container__radiobuttons">
		<p>{{ label }}</p>
		<div
			v-for="(option, index) in options"
			:key="option.label + index"
			:class="['container__radiobuttons__option', color]"
		>
			<input
				:id="groupName + index"
				type="radio"
				:checked="option.value === value.value"
				:name="groupName"
				:value="option.value"
				@click="changeValue($event)"
			/>

			<input
				v-show="option.left"
				:type="option.type"
				:placeholder="option.placeholder"
				:disabled="!option.value"
				:value="inputValor(option)"
				@input="changeInput($event, option)"
			/>
			<label :for="groupName + index">{{ option.label }}</label>
			<input
				v-show="option.right"
				:type="option.type"
				:placeholder="option.placeholder"
				style="margin-left: 0.5rem"
				:value="inputValor(option)"
				:disabled="!option.value"
				@input="changeInput($event, option)"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Nome do grupo de radio button
		 */
		groupName: String,
		/**
		 * label acima dos radio buttons
		 */
		label: String,
		/**
		 * Opções para os radios buttons
		 */
		options: Array,
		/**
		 * Valor que sera feito o bind
		 */
		value: [Object],
		color: {
			type: String,
			default: 'trv-default',
			validator: (value) => {
				return ['trv-default', 'trv-primary'].indexOf(value) !== -1
			},
		},
	},
	methods: {
		/**
		 * Evento para fazer o bind
		 */
		changeValue(event) {
			const value = event.target.value

			//verifica se valores são booleanos, faz conversão para booleano, evita emitir uma string 'false' ou 'true'
			if (value === 'false' || value === 'true') {
				this.$emit('input', { value: JSON.parse(event.target.value), input: undefined })
			} else {
				this.$emit('input', { value: event.target.value, input: undefined })
			}
		},
		changeInput(event, option) {
			const valorDigitado = event.target.value.split(' ')[0].trim()

			if (isNaN(valorDigitado)) {
				this.$emit('input', { value: option.value, input: event.target.value })
			} else {
				this.$emit('input', { value: option.value, input: Number.parseFloat(valorDigitado) })
			}
		},
		inputValor(option) {
			if (option.value === this.value.value) return this.value.input
			return ''
		},
	},
}
</script>

<style>
.container__radiobuttons {
	font-size: 0.75rem;
	color: rgb(var(--color-primary));
	user-select: none;
}

.container__radiobuttons > p {
	margin-bottom: 0.1rem;
}

.container__radiobuttons__option {
	display: flex;
	align-items: center;
}

.container__radiobuttons__option input[type='text'],
.container__radiobuttons__option input[type='number'] {
	width: 50px;
	border-radius: 5px;
	padding: 0.2rem;
	border: 1px solid var(--color-gray);
	text-align: center;
	-moz-appearance: textfield;
}

.container__radiobuttons__option input[type='number']::-webkit-inner-spin-button,
.container__radiobuttons__option input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.container__radiobuttons__option input[type='text']::placeholder,
.container__radiobuttons__option input[type='number']::placeholder {
	text-align: center;
}

.container__radiobuttons__option > input[type='radio'] {
	margin-right: 0.5rem;
	appearance: none;
	height: 15px;
	width: 15px;
	border-radius: 50%;
	position: relative;
	border: 2px solid #a9a9a9;
	outline: none;
}

.container__radiobuttons__option > input[type='radio']::before {
	position: absolute;
	content: '';
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	height: 0;
	width: 0;
	border-radius: 50%;
}

.container__radiobuttons__option.trv-default > input[type='radio']::before {
	background-color: rgb(var(--color-default));
}

.container__radiobuttons__option.trv-primary > input[type='radio']::before {
	background-color: rgb(var(--color-primary));
}

.container__radiobuttons__option > input[type='radio']:checked::before {
	height: 8px;
	width: 8px;
	transition: all 0.2s linear;
}

.container__radiobuttons__option > input[type='radio']:checked + label {
	font-weight: 700;
}
</style>
